<template>
    <div class="customer-nuztereigenschaften">
        <v-card>
            <v-card-title class="pt-2 pb-2">
                <TippTitle position="bottom" :tipp="about" title="Nutzereigenschaften" :loading="properties.loading" :reloadCb="getProperties" />
            </v-card-title>
            <v-card-text class="pt-0">
                <KeineDaten v-if="userproperties.length <= 0"></KeineDaten>
                <v-data-table
                    v-if="userproperties.length > 0"
                    hide-default-footer
                    disable-pagination
                    :headers="headers"
                    :items="userproperties"
                >
                    <template slot="item" slot-scope="props">
                        <tr :class="props.item.class">
                            <td>{{ props.item.store_id }}</td>
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.value }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import KeineDaten from '@/components/customer/KeineDaten.vue';
import TippTitle from '@/components/TippTitle.vue';

export default {
    name: 'Nutzereigenschaften',
    components: {
        KeineDaten,
        TippTitle,
    },
    data() {
        return {
            about: 'Zeigt die Eigenschaften und dazugehörigen Werte an, die ein Nutzer im CeleraOne-Store annehmen kann.',
            headers: [{
                text: 'Store',
                align: 'left',
                sortable: false,
                value: 'store_id',
            }, {
                text: 'Name',
                align: 'left',
                sortable: false,
                value: 'name',
            }, {
                text: 'Wert',
                align: 'left',
                sortable: false,
                value: 'value',
            }],
        };
    },
    computed: {
        ...mapGetters('customerDetail', ['userproperties']),
        ...mapState('customerDetail', ['properties']),
    },
    methods: mapActions('customerDetail', ['getProperties']),
};
</script>

<style scoped lang="scss"></style>
